import {
  useState, useEffect,
} from 'react';
import { ALL_PAGE_PUBLIC_STORAGE_KEY_PREFIX } from '../constants';

export default (spaceID: string): [boolean, (v: boolean) => void] => {
  const localStorageKey = ALL_PAGE_PUBLIC_STORAGE_KEY_PREFIX + spaceID;
  const [allPublic, setAllPublic] = useState(
    window.localStorage.getItem(localStorageKey) !== String(false),
  );

  useEffect(() => {
    setAllPublic(window.localStorage.getItem(localStorageKey) !== String(false));
  }, [spaceID]);

  const setter = (val: boolean) => {
    setAllPublic(val);
    window?.localStorage?.setItem(localStorageKey, String(val));
  };

  return [allPublic, setter];
};
